import S from 's-js';
import * as moment from 'moment';
import TZDate from './TZDate';
import 'moment-timezone';

export interface IClock {
    now() : TZDate;
    dispose() : void;
}

export class TZUtils {
    constructor(public timezone : string) { }

    // return a TZDate for the current time in the domain's timezone
    now() {
        return this.setTimezoneOffset(new Date(), false);
    }

    // return a TZDate for the start of today in the domain's timezone
    today() {
        var t = this.now();
        t.setHours(0), t.setMinutes(0), t.setSeconds(0), t.setMilliseconds(0);
        // If today is a dst boundary day, then midnight might've had a different offset than
        // now. Have to re-set offset in case.
        return this.setTimezoneOffset(t, true);
    }

    // return a TZDate for the specified numeric timestamp in the domain's timezone
    newDate(ts : number) {
        return this.setTimezoneOffset(new Date(ts), false);
    }

    // return a TZDate set to the correct timezone for the desired date
    setTimezoneOffset(date : TZDate | Date, changeUtc : boolean) {
        var tzdate = date instanceof TZDate ? date : new TZDate(+date, 0);

        // use the moment timezone library to figure out the correct timezone offset for the selected date
        var offset = this.timezone ? -moment(tzdate).tz(this.timezone).utcOffset() : date.getTimezoneOffset();

        // if date is in the wrong timezone, correct it
        if (tzdate.getTimezoneOffset() != offset) {
            tzdate.setTimezoneOffset(offset, changeUtc);
        }

        return tzdate;
    }

    // Clock w/ a now property set to tzutils.now.
    //   frequency -- frequency at which clock should tick in ms
    //
    // Calling clock.now in the context of a computed or pureComputed always returns tzutils.now,
    // plus creates a subscription to rerun the computation every time the clock ticks
    clock(frequency : number) : IClock {
        var tick = S.data(null),
            now = () => this.now(),
            interval = window.setInterval(function () { tick(null); }, frequency);

        S.cleanup(dispose);

        return {
            now: function () {
                // TH: The reason we don't just make an observable set to tzutils.now is that an observable wouldn't always be up-to-date.
                // I.e., an observable woud only be up-to-date when the clock ticks,
                // but if a caller came along and evaluated clock.now in between ticks, it'd get an old value.
                // Setting things up our way instead means calling clock.now always returns tzutils.now, whether or not the clock is in between ticks.
                tick();
                return now();
            },
            dispose
        };

        function dispose() {
            window.clearInterval(interval);
        }
    }

    // convert a TZDate to a browser-local date
    localify(date : TZDate | Date) {
        return date instanceof TZDate ? date.toBrowserLocalDate() : date;
    }

    // opposite of localify: convert the given Date object to a TZDate with the same local values but in the correct TZ
    tzify(date : TZDate | Date) {
        if (date instanceof TZDate) return this.setTimezoneOffset(date, true);
        var t = this.now();
            t.setDate(1); // bugfix: if the target month has fewer days than the current month, and if now() is in those final days, setting the target month moves us to the *following* month
            t.setFullYear(date.getFullYear());
            t.setMonth(date.getMonth());
            t.setDate(date.getDate());
            t.setHours(date.getHours());
            t.setMinutes(date.getMinutes());
            t.setSeconds(date.getSeconds());
            t.setMilliseconds(date.getMilliseconds());

        // if date is the opposite side of a dst change, have to re-set timezone
        t = this.setTimezoneOffset(t, true);
        return t;
    }
}


// WEBPACK FOOTER //
// ./lib/tzutils.ts